import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

const productLinks = [
  { to: "/tuerdruecker-stifte", label: "Türdrücker-Stifte" },
  { to: "/wechsel-schlossstifte", label: "Wechsel-Schlossstifte" },
  { to: "/psw-stifte", label: "PSW-Stifte" },
  { to: "/musterkarten-stift", label: "Musterkarten-Stift" },
  { to: "/vierkant-stifte", label: "Vierkant-Stifte" },
  { to: "/vierkant-stifte-abgesetzt", label: "Vierkant-Stifte abgesetzt" },
];

const mainLinks = [
  { to: "/", label: "Start", icon: "ri-home-4-line" },
  { to: "/unternehmen", label: "Unternehmen", icon: "ri-building-2-line" },
  { to: "/kontakt", label: "Kontakt", icon: "ri-mail-send-line" },
];

function BrandMark() {
  return (
    <Link to="/" className="flex items-center gap-3 group" aria-label="Franz Drexelius Startseite">
      <span className="flex flex-col items-center justify-center w-11 h-11 rounded-md bg-primary-600 text-background-50">
        <span className="text-[9px] font-label leading-none uppercase tracking-wide">seit</span>
        <span className="text-sm font-heading font-semibold leading-none mt-0.5">1956</span>
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-heading font-bold text-2xl md:text-3xl tracking-tight text-foreground-950">
          DREXELIUS
        </span>
        <span className="font-label text-[10px] md:text-[11px] tracking-[0.14em] uppercase text-primary-600 mt-1">
          Metallverarbeitung
        </span>
      </span>
    </Link>
  );
}

function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);

  const closeMenu = () => {
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50 border-b border-background-200">
      <div className="w-full px-4 md:px-8 py-3 flex items-center justify-between gap-4">
        <BrandMark />
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-label={open ? "Menü schließen" : "Menü öffnen"}
          className="flex items-center gap-2 h-10 pl-3.5 pr-4 rounded-md bg-foreground-950 text-background-50 font-label text-sm uppercase tracking-wide whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors"
        >
          <i className={open ? "ri-close-line text-lg" : "ri-menu-3-line text-lg"} aria-hidden="true" />
          <span>{open ? "Schließen" : "Menü"}</span>
        </button>
      </div>

      {open && (
        <div className="absolute right-0 top-full w-full sm:right-4 sm:w-[21rem] max-h-[calc(100vh-4.5rem)] overflow-y-auto rounded-b-lg sm:rounded-lg border border-background-200 bg-background-50 p-3 animate-rise">
          <button
            type="button"
            onClick={() => setProductsOpen((v) => !v)}
            aria-expanded={productsOpen}
            className="w-full flex items-center justify-between gap-3 rounded-md bg-primary-600 text-background-50 px-3.5 py-2.5 cursor-pointer hover:bg-primary-500 transition-colors"
          >
            <span className="flex items-center gap-2 font-heading font-semibold text-base">
              <i className="ri-price-tag-3-line text-lg" aria-hidden="true" />
              Produkte
            </span>
            <i className={productsOpen ? "ri-subtract-line text-lg" : "ri-add-line text-lg"} aria-hidden="true" />
          </button>

          {productsOpen && (
            <nav aria-label="Produktnavigation" className="mt-1.5 flex flex-col">
              {productLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  onClick={closeMenu}
                  className={({ isActive }) =>
                    `flex items-center gap-2 px-3 py-2 rounded-md font-label text-sm transition-colors ${
                      isActive
                        ? "bg-secondary-100 text-primary-700"
                        : "text-foreground-800 hover:bg-background-100 hover:text-primary-700"
                    }`
                  }
                >
                  <i className="ri-arrow-right-s-line text-primary-500 text-base" aria-hidden="true" />
                  {link.label}
                </NavLink>
              ))}
            </nav>
          )}

          <nav
            aria-label="Hauptnavigation"
            className="mt-2 pt-2 border-t border-background-200 flex flex-col"
          >
            {mainLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                onClick={closeMenu}
                className={({ isActive }) =>
                  `flex items-center gap-2.5 px-3 py-2.5 rounded-md font-label text-sm transition-colors ${
                    isActive
                      ? "bg-secondary-100 text-primary-700"
                      : "text-foreground-800 hover:bg-background-100 hover:text-primary-700"
                  }`
                }
              >
                <i className={`${link.icon} text-primary-600 text-base`} aria-hidden="true" />
                {link.label}
              </NavLink>
            ))}
          </nav>

          <a
            href="tel:+4927217237"
            className="mt-2 flex items-center justify-center gap-2 h-10 rounded-md border border-foreground-300 text-foreground-950 font-label text-sm uppercase tracking-wide whitespace-nowrap hover:bg-background-100 transition-colors"
          >
            <i className="ri-phone-line text-base text-primary-600" aria-hidden="true" />
            Anrufen · 0 27 21 / 72 37
          </a>
        </div>
      )}
    </header>
  );
}

export default SiteHeader;